import { Link  } from "react-router-dom"; 
import { FcOrgUnit,FcConferenceCall,FcStatistics } from "react-icons/fc";
import HandleCurrentPath from "./HandleCurrentPath";
const Menu = () =>{

  const pathname = window.location.pathname;
 
    return(
        <>
        <ul className="mt-6">
                <li className="relative px-6 py-3">
                 
                <HandleCurrentPath staticPath={'/'} currentPath={pathname} />
                <Link
                    className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                    to={"/"}
                >
                    <FcOrgUnit />
                    <span className="ml-4">Run Draw!</span> 
                </Link>
                </li>

                <li className="relative px-6 py-3">
                 
                 <HandleCurrentPath staticPath={'/winners'} currentPath={pathname} />
                 <Link
                     className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                     to={"/winners"}
                 >
                     <FcConferenceCall />
                     <span className="ml-4">Previous Winners</span> 
                 </Link>
                 </li>

                 <li className="relative px-6 py-3">
                 
                 <HandleCurrentPath staticPath={'/subscriptions'} currentPath={pathname} />
                 <Link
                     className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
                     to={"/subscriptions"}
                 >
                     <FcStatistics />
                     <span className="ml-4">Subscription Stats</span> 
                 </Link>
                 </li>


            </ul>

        <ul>
 

  
  </ul>
        </>
    );
}
export default Menu;